"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HandleRoundedArrow = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icons = require("@material-ui/icons");
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const HandleRoundedArrow = _ref => {
  let {
    props,
    screenSize,
    direction,
    disabled
  } = _ref;
  const useStyles = (0, _core.makeStyles)(theme => ({
    arrow: {
      color: theme.palette.text.secondary
    },
    hidden: {
      opacity: 0
    }
  }));
  const classes = useStyles();
  const arrowDirection = direction || props?.direction;
  if (arrowDirection === 'left') {
    return /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowLeftRounded, _extends({
      classes: {
        root: classes.arrow
      },
      style: screenSize !== 'mobile' ? {
        marginTop: 12,
        width: 40
      } : {
        marginTop: 16,
        width: 40
      }
    }, props));
  }
  if (arrowDirection === 'right') {
    return /*#__PURE__*/_react.default.createElement(_icons.KeyboardArrowRightRounded, _extends({
      classes: {
        root: classes.arrow
      },
      style: screenSize !== 'mobile' ? {
        marginTop: 12,
        width: 40
      } : {
        marginTop: 16,
        width: 40
      }
    }, props));
  }
  return null;
};
exports.HandleRoundedArrow = HandleRoundedArrow;
HandleRoundedArrow.propTypes = {
  props: _propTypes.default.object,
  direction: _propTypes.default.string,
  screenSize: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool
};
HandleRoundedArrow.defaultProps = {
  disabled: false,
  props: {}
};
var _default = exports.default = HandleRoundedArrow;